

  <router-outlet></router-outlet>



  <!-- Scroll Top -->
  <a href="#" id="scroll-top" class="scroll-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>

  <!-- Preloader -->
  <!-- <div id="preloader"></div> -->

<ngx-spinner 
bdColor = "rgba(0, 0, 0, 0.7)"
 size = "medium" color = "#D4AF37" 
 type = "square-jelly-box" 
 [fullScreen] = "true">
 <p style="color: white;font-size: 1.6rem;"  > Loading... </p>
</ngx-spinner>